import { useEffect, useRef, useState } from "react";
import type { TimelineEventRow } from "./opsPaperworkTypes";

export function OpsDealAuditMenu(props: {
  timeline: TimelineEventRow[];
  externalIds: unknown[];
}) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e: MouseEvent) => {
      if (!rootRef.current?.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  return (
    <div ref={rootRef} className="relative inline-block">
      <button
        type="button"
        className="inline-flex h-6 w-6 items-center justify-center rounded-full border border-gray-300 text-xs font-bold text-gray-600 hover:bg-gray-50 dark:border-zinc-600 dark:text-zinc-300 dark:hover:bg-zinc-800"
        aria-label="Deal timeline and external IDs"
        aria-expanded={open}
        aria-haspopup="dialog"
        title="Deal timeline and external IDs"
        onClick={() => setOpen((v) => !v)}
      >
        ?
      </button>
      {open ? (
        <div className="absolute right-0 z-20 mt-1 w-[min(28rem,calc(100vw-2rem))] space-y-3 rounded-xl border border-gray-200 bg-white p-3 shadow-lg dark:border-zinc-700 dark:bg-zinc-900">
          <section>
            <h4 className="mb-1 text-sm font-semibold text-gray-800 dark:text-zinc-100">Deal timeline (audit)</h4>
            <ul className="max-h-48 space-y-1 overflow-auto text-sm">
              {props.timeline.map((ev) => (
                <li key={ev.id} className="border-b border-gray-100 py-1 dark:border-zinc-800">
                  <span className="font-mono text-xs text-indigo-700 dark:text-indigo-300">{ev.event_type}</span>
                  {ev.body ? <span className="text-gray-700 dark:text-zinc-300"> — {ev.body}</span> : null}
                  <span className="block text-xs text-gray-500">{new Date(ev.created_at).toLocaleString()}</span>
                </li>
              ))}
              {props.timeline.length === 0 ? <li className="text-gray-500">No timeline rows yet.</li> : null}
            </ul>
          </section>
          <section>
            <h4 className="mb-1 text-sm font-semibold text-gray-800 dark:text-zinc-100">External ids</h4>
            <pre className="max-h-32 overflow-auto rounded bg-gray-50 p-2 text-xs dark:bg-zinc-950">
              {JSON.stringify(props.externalIds, null, 2)}
            </pre>
          </section>
        </div>
      ) : null}
    </div>
  );
}
